import { request } from '../lib/http'

/**
 * @returns {Promise<Array>}
 */
export function fetchAll () {
  return request({
    url: 'bank-account',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `bank-account`,
    method: 'get',
    params: queriesParams
  })
}

/**
 * @param {Object} bankaccount
 * @param {String} bankaccount.bank
 * @param {String} bankaccount.agency
 * @param {String} bankaccount.account
 * @param {String} bankaccount.type
 * @param {String} bankaccount.name
 * @param {String} bankaccount.cpfCnpj
 * @returns {Promise<Object>} Promise com o usuario criado.
 */
export function addBankAccount (bankAccount) {
  return request({
    method: 'post',
    url: 'bank-account',
    data: bankAccount
  })
}

/**
 * @param {Number} id
 * @returns {Promise<Object>}
 */
export function show (id) {
  return request({
    url: `bank-account/${id}`,
    method: 'get'
  })
}

/**
 * @param {Object} bankaccount
 * @param {String} bankaccount.bank
 * @param {String} bankaccount.agency
 * @param {String} bankaccount.account
 * @param {String} bankaccount.type
 * @param {String} bankaccount.name
 * @param {String} bankaccount.cpfCnpj
 * @returns {Promise<Object>}
 */
export function edit (id, data) {
  return request({
    url: `bank-account/${id}`,
    method: 'patch',
    data
  })
}
